import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const CookiesBlocked = ({ options }) => {
  const {
    theme,
    sharedTheme,
    rendered,
    backgroundInline,
    onSignInButtonClick,
    getChildren,
  } = options;
  const innerContainerStyle = backgroundInline ? { ...backgroundInline } : null;
  const children = getChildren({ onSignInButtonClick });

  if (!rendered) return null;

  return (
    <div className={classNames(sharedTheme.container, theme.container)}>
      <div
        className={classNames(sharedTheme.innerContainer, theme.innerContainer)}
        style={innerContainerStyle}
      >
        <div className={theme.content}>{children}</div>
      </div>
    </div>
  );
};

CookiesBlocked.propTypes = {
  options: PropTypes.shape({}),
};

CookiesBlocked.defaultProps = {
  options: {},
};

export default CookiesBlocked;
